import { KnownUserStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { ListPageHeaderProps } from '../../../../ui/components/pure/page-headers/list/list-page-header.component';
import { CouriersListControlsState } from './couriers-list-query.map';
import { CourierListActions, makeDefineCouriersListActions } from '../actions/courier-list.actions';
import { Permissions } from '../../../../core/permissions/permissions.typings';

export function makeCouriersListPageHeaderProps(
  couriersCount: number,
  form: CouriersListControlsState,
  onFormInput: (update: Partial<CouriersListControlsState>) => void,
  carrierOptions: { label: string; value: string }[],
  setAction: (action: CourierListActions) => void,
  projectID: string
): ListPageHeaderProps<CouriersListControlsState> {
  return {
    title: 'Couriers',
    subtitle: `${couriersCount} ${couriersCount === 1 ? 'Courier' : 'Couriers'}`,
    controls: {
      form,
      onFormInput,
      inputs: [
        {
          type: 'select',
          label: '',
          field: 'status',
          options: CourierStatusOptions,
          isAdvanced: true,
          halfWidthOnMobile: true
        },
        {
          type: 'auto-complete',
          label: 'Carrier',
          field: 'groupID',
          options: carrierOptions,
          isAdvanced: true,
          halfWidthOnMobile: true
        },
        {
          type: 'text',
          label: 'Search',
          field: 'searchTerm'
        }
      ],
      singleAction: {
        label: 'Add new',
        onClick: () => setAction(CourierListActions.ADD_COURIER),
        permission: { action: Permissions.users.create, projectID }
      },
      menu: {
        actions: makeDefineCouriersListActions(projectID)(setAction)
      }
    }
  };
}

// Deleted couriers are never included unless explicitly asked for — 'all' sends no status
// filter, which the API answers with active and inactive only (see users.repository.ts), so
// the label says what it actually returns rather than promising every status.
// 'pending' is a self-registration awaiting approval, not an error state.
// No 'incomplete': those couriers are in network phone groups, not carriers. See Incomplete Couriers.
const CourierStatusOptions = [
  { label: 'Active & Inactive', value: 'all' },
  { label: 'Active Only', value: KnownUserStatus.Active },
  { label: 'Pending Only', value: KnownUserStatus.Pending },
  { label: 'Inactive Only', value: KnownUserStatus.Inactive },
  { label: 'Deleted Only', value: KnownUserStatus.Deleted }
];
